<script>
import {useToast} from "vue-toastification";
import assetMaterialsHelper from "@/mixins/assetMaterialsHelper";

export default {
  mixins: [
    assetMaterialsHelper
  ],
  props: [
    'modelValue',
    'clientId',
    'assetType' // For example: 'ovl_pole' or 'ovl_lamp'
  ],
  emits: ['update:modelValue', 'dialog-closed'],
  async mounted() {
    // Set default value
    this.dialogDatabaseMaterials = this.dialogDatabaseMaterialsDefault;
    // Setup toast
    this.toast = useToast()
    // Get CSRF token
    await this.requestGetCSRFtoken();
    // Get asset types
    await this.getAssetTypes('ovl');

    this.formInNewMaterialMode = false;
  },
  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage)
  },
  data () {
    return {
      toast: null,
      userCSRFToken: '',
      formInNewMaterialMode: false,
      assetTypes: [],
      dialogLoading: false,
      dialogPage: 1,
      search: '',
      dialogDatabaseMaterials: {},
      dialogDatabaseMaterialsDefault: {
        rows: [],
        pager: {
          total_pages: 0,
          total_items: 0,
          items_per_page: 20,
        },
      },
    }
  },
  computed: {
    dialogDatabaseHeaders() {
      // Set default headers
      let headers = [
        {
          title: '',
          key: 'select_material',
          sortable: false,
        },
        {
          title: 'Materiaalnaam',
          align: 'start',
          key: 'label',
          sortable: false,
        },
      ];
      // Add extra headers for each type
      if (this.assetType === 'ovl_lamp') {
        headers.push(
          {
            title: 'Fabrikant',
            key: 'manufacturer',
            sortable: false,
          },
          {
            title: 'Levensduur',
            key: 'lifespan_value',
            sortable: false,
          },
          {
            title: 'Vermogen',
            key: 'power_value',
            sortable: false,
          },
        );
      }
      else if (this.assetType === 'ovl_pole') {
        headers.push(
            {
              title: 'Hoogte',
              key: 'height_value',
              sortable: false,
            },
            {
              title: 'Mastmodel',
              key: 'pole_model',
              sortable: false,
            },
            {
              title: 'Materiaal',
              key: 'pole_material',
              sortable: false,
            },
            {
              title: 'Fabrikant',
              key: 'manufacturer',
              sortable: false,
            },
            {
              title: 'Levensduur',
              key: 'lifespan_value',
              sortable: false,
            },
        );
      }
      else if (this.assetType === 'ovl_fixture') {
        headers.push(
            {
              title: 'Fabrikant',
              key: 'manufacturer',
              sortable: false,
            },
            {
              title: 'Levensduur',
              key: 'lifespan_value',
              sortable: false,
            },
            {
              title: 'Lumen output',
              key: 'lumen_output_value',
              sortable: false,
            },
        );
      }
      else if (this.assetType === 'ovl_vsa') {
        headers.push(
            {
              title: 'Fabrikant',
              key: 'manufacturer',
              sortable: false,
            },
            {
              title: 'Levensduur',
              key: 'lifespan_value',
              sortable: false,
            },
            {
              title: 'Vermogen',
              key: 'power_value',
              sortable: false,
            },
        );
      }
      else if (this.assetType === 'ovl_bracket') {
        headers.push(
          {
            title: 'Fabrikant',
            key: 'manufacturer',
            sortable: false,
          },
        );
      }
      else if (this.assetType === 'ovl_misc_material') {
        headers.push(
          {
            title: 'Materiaaltype',
            key: 'misc_material',
            sortable: false,
          },
          {
            title: 'Fabrikant',
            key: 'manufacturer',
            sortable: false,
          },
        );
      }

      headers.push({
        title: 'Aantal in areaal',
        key: 'amount_in_use',
        sortable: false,
      });

      return headers;
    },
    pageCount () {
      return parseInt(this.dialogDatabaseMaterials.pager.total_pages);
    },
    dialogTotalItems () {
      return parseInt(this.dialogDatabaseMaterials.pager.total_items);
    },
    dialogItemsPerPage () {
      return parseInt(this.dialogDatabaseMaterials.pager.items_per_page);
    }
  },
  watch: {
    assetType: {
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          window.addEventListener('message', this.receiveMessage, false)
        }
        else {
          window.removeEventListener('message', this.receiveMessage)
        }
      },
      immediate: true
    },
  },
  methods: {
    async receiveMessage(event) {
      if (!this.iframeUrl().startsWith(event.origin)) {
        return;
      }

      if (event.data.func === 'iframeAddedMaterial') {
        this.formInNewMaterialMode = false;
        var json = JSON.parse(event.data.material);

        await this.selectMaterial(json);
      }

    },
    iframeUrl() {
      return import.meta.env.VITE_API_BASEURL + 'modal/database/' + this.clientId + '/ovl/'+ this.assetType + '/add'
    },
    closeDialog() {
      // Reset to default value
      this.dialogDatabaseMaterials = this.dialogDatabaseMaterialsDefault;
      this.formInNewMaterialMode = false;
      // Emit event
      this.$emit('dialog-closed')
    },
    async selectMaterial(database_material) {
      this.formInNewMaterialMode = false;
      // Emit event
      this.$emit('material-selected', {selected_material: database_material})
    },
    databaseMaterialUpdateOptions({ page, itemsPerPage, sortBy }) {
      if (this.modelValue) {
        this.dialogPage = page;
        this.requestGetDatabaseMaterials();
      }
    },
    async requestGetDatabaseMaterials() {
      this.dialogLoading = true;
      let url = import.meta.env.VITE_API_BASEURL + 'api/select-material/'+ this.clientId +'/' + this.assetType;
      let params = {
        page: this.dialogPage - 1,
        combine: this.search,
      }
      // Fetch session token
      const response = await fetch(url + '?' + new URLSearchParams(params), {
        credentials: "include"
      })
      const response_json = await response.json();
      // Set database materials
      this.dialogDatabaseMaterials = response_json;
      this.dialogLoading = false;
    },
    addNewMaterialForm() {
      this.formInNewMaterialMode = true;
    },
  },
}
</script>

<template>

  <v-dialog
    :model-value="modelValue"
    @click:outside="closeDialog()"
  >
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <template v-if="assetType">Selecteer {{ assetTypes[assetType] }}</template>
          <v-btn icon="mdi-close" color="error" class="text-white" size="small" @click="closeDialog()"></v-btn>
        </div>
      </v-card-title>
      <v-card-text style="min-height: 600px;">
        <v-btn icon="mdi-plus" v-if="!formInNewMaterialMode" @click="addNewMaterialForm()"></v-btn>
          <iframe v-if="formInNewMaterialMode" height="100%" width="100%" style="min-height: 600px;" :src="iframeUrl()"></iframe>
        <!-- TODO: Add extra tab for 'Gebruikt in areaal" here. This query needs to go over the 'asset_materials' instead of the 'database' entities. -->

        <!-- TODO: Add table sort and filters. See databaseMaterialUpdateOptions() to add sort. Also add 'sort: true' on the this.dialogDatabaseHeaders array. -->

        <v-data-table-server
          v-if="!formInNewMaterialMode"
          class="database-materials"
          :headers="dialogDatabaseHeaders"
          :items="dialogDatabaseMaterials.rows"
          :items-per-page="dialogItemsPerPage"
          :items-length="dialogTotalItems"
          item-value="name"
          :items-per-page-options="[{value: 20, title: '20'}]"
          :search="search"
          fixed-header
          fixed-footer
          loading-text="Laden.."
          :loading="dialogLoading"
          @update:options="databaseMaterialUpdateOptions"
        >
          <template v-slot:thead>
            <tr>
              <td></td>
              <td colspan="3">
                <v-text-field v-model="search" class="ma-2" density="compact" placeholder="Zoek materiaal..." hide-details></v-text-field>
              </td>
            </tr>
          </template>
          <template #item.select_material="{ item }">
            <v-btn @click="selectMaterial(item)" variant="text" color="primary">
              Selecteer
            </v-btn>
          </template>
        </v-data-table-server>

      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<style lang="scss">
  .database-materials {
    table {
      margin: 0;
    }
    .v-data-table-footer__items-per-page {
      display: none;
    }
  }
</style>
